import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Exam } from './interfaces/exams.service/types';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  public examUnSigned$: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {}

  uploadSignature(file: File) {
    const formData = new FormData();
    formData.append('signature', file, file.name);
    return this.http.post('/api/consent/uploadSignature', formData);
  }

  checkSignatureExists(uid?: string) {
    const params = uid ? { uid } : {};
    return this.http.get('/api/consent/getSignatureImage', { params, responseType: 'blob' });
  }

  deleteSignature() {
    return this.http.post('/api/consent/deleteSignature', {});
  }

  uploadSignatureForUid(uid: string, file: File) {
    const formData = new FormData();
    formData.append('signature', file, file.name);
    formData.append('uid', uid);
    return this.http.post('/api/consent/uploadSignatureForUid', formData);
  }

  deleteSignatureForUid(uid: string) {
    return this.http.post('/api/consent/deleteSignatureForUid', { uid });
  }

  isExamSigned(exam: Exam): boolean {
    const isDraft = exam?.Draft;
    const signedBy = exam?.SignedBy;
    const signedDate = exam?.SignedDate;

    if (!isDraft && signedBy && signedDate) {
      return true;
    }

    return false;
  }

  async unSignExam(examId: number) {
    const data = {
      isDraft: true,
      signedBy: null,
      signedDate: null,
      closedDate: null,
    };

    try {
      return this.http.post(`/api/newExams/signature/un-sign/${examId}`, data);
    } catch (error) {
      console.log(error);
    }
  }

  canDeleteExam(exam: Exam = null): boolean {
    const signatureCount = exam.SignatureCount;
    if (signatureCount) {
      return false;
    }
    return true;
  }
}
